import jsPDF from 'jspdf';
import { MappedFlight } from '../services/flightService';
import { FlightSearchParams } from '../services/flightService';
import { formatFlightDate, formatFlightTime } from './flightDateTime';

const LOGO_B64 = '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';
const BLUE = '#1E90FF';
const DARK = '#1a1a2e';
const GRAY = '#666666';
const LIGHT_GRAY = '#f5f7fa';
const W = 210;
const MARGIN = 14;

// Horário de voo: wall-clock do aeroporto (sem conversão de fuso).
const fmtDT = (iso: string) => {
  const date = formatFlightDate(iso);
  const time = formatFlightTime(iso);
  return date ? `${date} ${time}` : time;
};
const fmtP = (v: number) =>
  v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

function hex(h: string): [number, number, number] {
  const n = parseInt(h.replace('#', ''), 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}

export function generateQuotePDF(
  outbound: MappedFlight,
  ret: MappedFlight | null,
  params: FlightSearchParams,
  total: number,
  paymentUrl?: string,
) {
  const doc = new jsPDF({ unit: 'mm', format: 'a4' });
  let y = 0;

  // ── header bar ──────────────────────────────────────────────────────────────
  doc.setFillColor(...hex(BLUE));
  doc.rect(0, 0, W, 28, 'F');

  // logo SVG como imagem
  try {
    doc.addImage(
      'data:image/svg+xml;base64,' + LOGO_B64,
      'SVG', MARGIN, 7, 46, 9,
    );
  } catch {
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(16); doc.setFont('helvetica', 'bold');
    doc.text('999 Viagens', MARGIN, 17);
  }

  doc.setTextColor(255, 255, 255);
  doc.setFontSize(11); doc.setFont('helvetica', 'bold');
  doc.text('Cotação de Passagem Aérea', W - MARGIN, 13, { align: 'right' });
  doc.setFontSize(8); doc.setFont('helvetica', 'normal');
  doc.text(`Gerado em ${new Date().toLocaleString('pt-BR')}`, W - MARGIN, 20, { align: 'right' });

  y = 36;

  // ── função de bloco de voo ───────────────────────────────────────────────────
  const flightBlock = (label: string, f: MappedFlight) => {
    // label pill
    doc.setFillColor(...hex(BLUE));
    doc.roundedRect(MARGIN, y, 30, 6, 1.5, 1.5, 'F');
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(8); doc.setFont('helvetica', 'bold');
    doc.text(label, MARGIN + 15, y + 4.2, { align: 'center' });
    y += 9;

    // card background
    doc.setFillColor(...hex(LIGHT_GRAY));
    doc.roundedRect(MARGIN, y, W - MARGIN * 2, 34, 2, 2, 'F');

    // airline + flight number
    doc.setTextColor(...hex(DARK));
    doc.setFontSize(12); doc.setFont('helvetica', 'bold');
    doc.text(f.airlineName.toUpperCase(), MARGIN + 4, y + 8);
    doc.setFontSize(8); doc.setFont('helvetica', 'normal');
    doc.setTextColor(...hex(GRAY));
    doc.text(`Voo ${f.flightNumber}${f.cabin ? '  ·  ' + f.cabin : ''}`, MARGIN + 4, y + 13);

    // route line: DEP → ARR
    const cx = W / 2;
    doc.setTextColor(...hex(DARK));
    doc.setFontSize(14); doc.setFont('helvetica', 'bold');
    doc.text(f.departureLocation, cx - 28, y + 10, { align: 'right' });
    doc.text(f.arrivalLocation, cx + 28, y + 10, { align: 'left' });

    // arrow line
    doc.setDrawColor(...hex(BLUE));
    doc.setLineWidth(0.4);
    doc.line(cx - 20, y + 8.5, cx + 20, y + 8.5);
    doc.setFillColor(...hex(BLUE));
    doc.triangle(cx + 20, y + 7.5, cx + 20, y + 9.5, cx + 23, y + 8.5, 'F');

    // times
    doc.setFontSize(8); doc.setFont('helvetica', 'normal');
    doc.setTextColor(...hex(GRAY));
    doc.text(fmtDT(f.departureTime), cx - 28, y + 15, { align: 'right' });
    doc.text(fmtDT(f.arrivalTime), cx + 28, y + 15, { align: 'left' });

    // duration + stops
    doc.setTextColor(...hex(BLUE));
    doc.setFontSize(8);
    doc.text(`${f.flightDuration}${f.qntStop > 0 ? '  ·  ' + f.qntStop + ' escala(s)' : '  ·  Direto'}`, cx, y + 21, { align: 'center' });

    // price per pax
    doc.setTextColor(...hex(DARK));
    doc.setFontSize(10); doc.setFont('helvetica', 'bold');
    doc.text(fmtP(f.ourPrice + f.tax), W - MARGIN - 4, y + 10, { align: 'right' });
    doc.setFontSize(7); doc.setFont('helvetica', 'normal');
    doc.setTextColor(...hex(GRAY));
    doc.text('por passageiro', W - MARGIN - 4, y + 15, { align: 'right' });

    y += 38;
  };

  flightBlock('VOO DE IDA', outbound);
  if (ret) { y += 2; flightBlock('VOO DE VOLTA', ret); }

  y += 4;

  // ── divider ──────────────────────────────────────────────────────────────────
  doc.setDrawColor(220, 220, 220);
  doc.setLineWidth(0.3);
  doc.line(MARGIN, y, W - MARGIN, y);
  y += 6;

  // ── passageiros ──────────────────────────────────────────────────────────────
  doc.setFontSize(8); doc.setFont('helvetica', 'normal'); doc.setTextColor(...hex(GRAY));
  const paxStr = [
    params.adults > 0 ? `${params.adults} adulto(s)` : '',
    params.children > 0 ? `${params.children} criança(s)` : '',
    params.babies > 0 ? `${params.babies} bebê(s)` : '',
  ].filter(Boolean).join('  ·  ');
  doc.text(paxStr, MARGIN, y);
  y += 8;

  // ── total box ────────────────────────────────────────────────────────────────
  doc.setFillColor(...hex(BLUE));
  doc.roundedRect(MARGIN, y, W - MARGIN * 2, 14, 2, 2, 'F');
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(9); doc.setFont('helvetica', 'normal');
  doc.text('TOTAL DA COTAÇÃO', MARGIN + 6, y + 5.5);
  doc.setFontSize(14); doc.setFont('helvetica', 'bold');
  doc.text(fmtP(total), W - MARGIN - 6, y + 9.5, { align: 'right' });
  y += 20;

  // ── validade ─────────────────────────────────────────────────────────────────
  doc.setFontSize(7.5); doc.setFont('helvetica', 'italic'); doc.setTextColor(...hex(GRAY));
  doc.text('* Preços sujeitos a disponibilidade. Cotação válida por 24 horas.', MARGIN, y);
  y += 8;

  // ── link de pagamento ─────────────────────────────────────────────────────────
  if (paymentUrl) {
    doc.setFillColor(232, 245, 233);
    doc.roundedRect(MARGIN, y, W - MARGIN * 2, 18, 2, 2, 'F');
    doc.setDrawColor(165, 214, 167);
    doc.roundedRect(MARGIN, y, W - MARGIN * 2, 18, 2, 2, 'S');
    doc.setFontSize(8); doc.setFont('helvetica', 'bold'); doc.setTextColor(46, 125, 50);
    doc.text('LINK DE PAGAMENTO', MARGIN + 4, y + 6);
    doc.setFontSize(7.5); doc.setFont('helvetica', 'normal'); doc.setTextColor(21, 101, 192);
    const lines = doc.splitTextToSize(paymentUrl, W - MARGIN * 2 - 8);
    doc.textWithLink(lines[0], MARGIN + 4, y + 12, { url: paymentUrl });
    y += 22;
  }

  // ── footer ───────────────────────────────────────────────────────────────────
  const pageH = 297;
  doc.setFillColor(...hex(BLUE));
  doc.rect(0, pageH - 12, W, 12, 'F');
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(7.5); doc.setFont('helvetica', 'normal');
  doc.text('999 Viagens  ·  www.999viagens.com.br', W / 2, pageH - 5, { align: 'center' });

  doc.save(`cotacao-999viagens-${Date.now()}.pdf`);
}
